import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RushCelebrationWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  width: '324px',
  top: 30,
  zIndex: 1,
  // marginTop: '-30px',
  [theme.breakpoints.down('md')]: {
    top: 10,
  },
}));

export const RushCelebrationContent = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
}));
